export default __webpack_public_path__ + "static/large-cabin-outside1-051663ebb19622e94f0be1249ec39fcf.jpg";